class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.mainNav = document.querySelector(".main-nav");
  }

  onToggle() {
    // Call parent class onToggle first
    super.onToggle();

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.hasAttribute("open");

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );

    // Add or remove menu-open class based on open state
    if (this.mainNav) {
      if (this.mainDetailsToggle.hasAttribute("open")) {
        this.mainNav.classList.add("menu-open");
      } else {
        this.mainNav.classList.remove("menu-open");
      }
    }
  }

  close() {
    super.close();
    if (this.mainNav) {
      this.mainNav.classList.remove("menu-open");
    }
  }
}

customElements.define("header-menu", HeaderMenu);
